export const GuestsLimits = {
  adults: {
    min: 1,
    max: 10,
    default: 2,
  },
  children: {
    min: 0,
    max: 5,
    default: 0,
  },
  childAge: {
    min: 0,
    max: 17,
    default: 5,
  },
} as const
